var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.data)?_c('Empty'):_c('div',{staticClass:"module-rich_text jm-editor",domProps:{"innerHTML":_vm._s(_vm.data)}})
}
var staticRenderFns = []

export { render, staticRenderFns }